import { DUMMY_SKU_LITA } from './constants'

export const isDummyLitaProduct = product => {
  return (
    product?.Sku === DUMMY_SKU_LITA ||
    product?.SystemCode === DUMMY_SKU_LITA ||
    product?.referencia === DUMMY_SKU_LITA
  )
}
